import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-modal-window",
    styleUrls: ["./modal-window.component.scss"],
    templateUrl: "./modal-window.component.html",
    standalone: false
})
export class FUIModalWindowComponent {
    @Input() public alert: boolean;
    @Input() public icon: string;
    @Input() public title: string;

    constructor() {

    }
}
